


import React, {useEffect, useState} from 'react';


import {NavigationContainer} from '@react-navigation/native';
import MainNavigation from './navigation/MainNavigation';


import 'react-native-get-random-values';
import 'react-native-url-polyfill/auto';
import { configureAmplify } from './auth/amplifyConfig';
configureAmplify();

const App =  () => {

  // Declare state variables to hold the value of each TextInput
      return  (
        <NavigationContainer>
        <MainNavigation/>
        </NavigationContainer>
      )
};

export default App;
